<script>
  import { onMount, onDestroy } from 'svelte';

  let visible = false;
  let scrollHandler;

  onMount(() => {
    scrollHandler = () => {
      visible = window.scrollY > 400;
    };
    scrollHandler();
    window.addEventListener('scroll', scrollHandler, { passive: true });
  });

  onDestroy(() => {
    if (scrollHandler) window.removeEventListener('scroll', scrollHandler);
  });

  function goTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
</script>

<button
  class="back-to-top"
  type="button"
  aria-label="Наверх"
  on:click={goTop}
  class:is-visible={visible}
>
  <span class="arrow" aria-hidden="true"></span>
</button>

<style>
  .back-to-top {
    position: fixed;
    right: 24px;
    bottom: 24px;
    z-index: 50;
    display: inline-flex;
    width: 48px;
    height: 48px;
    align-items: center;
    justify-content: center;
    padding: 0;
    border: 0;
    border-radius: 50%;
    background: #e7b962;
    color: #000000;
    cursor: pointer;
    opacity: 0;
    pointer-events: none;
    transform: translateY(8px);
    transition: opacity 200ms ease, transform 200ms ease, background 160ms ease;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.45);
  }

  .back-to-top.is-visible {
    opacity: 1;
    pointer-events: auto;
    transform: translateY(0);
  }

  .back-to-top:hover,
  .back-to-top:focus-visible {
    background: #ffffff;
  }

  .arrow {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-top: 2px solid currentColor;
    border-right: 2px solid currentColor;
    transform: translateY(2px) rotate(-45deg);
  }

  @media (max-width: 767px) {
    .back-to-top {
      right: 16px;
      bottom: 16px;
      width: 44px;
      height: 44px;
    }
  }
</style>
